import { useEffect, useRef } from 'react'

declare global {
  interface Window {
    googletag: any
  }
}

const isMobile = () => typeof window !== 'undefined' && window.innerWidth < 768

export function useGptInit(
  pageType: 'Homepage' | 'Category' | 'Article' = 'Homepage',
) {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    // Initialize googletag command queue
    window.googletag = window.googletag || { cmd: [] }

    // Load GPT script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js'
    document.head.appendChild(script)

    // Define slots
    window.googletag.cmd.push(function () {
      const googletag = window.googletag
      const mobile = isMobile()

      if (pageType === 'Homepage') {
        if (mobile) {
          // HOMEPAGE MOBILE
          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [
                [320, 50],
                [320, 100],
                [320, 150],
              ],
              'div-gpt-ad-1725237-1',
            )
            .setTargeting('Pos', ['Mobile_Leaderboard'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[300, 250]],
              'div-gpt-ad-1725237-2',
            )
            .setTargeting('Pos', ['Mobile_MPU'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[300, 600]],
              'div-gpt-ad-1725237-3',
            )
            .setTargeting('Pos', ['Mobile_Halfpage'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[1, 1]],
              'div-gpt-ad-1725237-4',
            )
            .setTargeting('Pos', ['FPI'])
            .addService(googletag.pubads())
        } else {
          // HOMEPAGE DESKTOP
          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [
                [728, 90],
                [970, 250],
                [1000, 300],
                [1000, 500],
              ],
              'div-gpt-ad-9285715-1',
            )
            .setTargeting('Pos', ['Leaderboard'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [
                [728, 90],
                [970, 250],
                [1000, 300],
                [1000, 500],
              ],
              'div-gpt-ad-9285715-1-2',
            )
            .setTargeting('Pos', ['Billboard'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[300, 250]],
              'div-gpt-ad-9285715-2',
            )
            .setTargeting('Pos', ['MPU'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[300, 600]],
              'div-gpt-ad-9285715-3',
            )
            .setTargeting('Pos', ['Halfpage'])
            .addService(googletag.pubads())

          googletag
            .defineSlot(
              '/23306254316/Communicate-Web/Homepage',
              [[1, 1]],
              'div-gpt-ad-9285715-4',
            )
            .setTargeting('Pos', ['Skin'])
            .addService(googletag.pubads())
        }
      }

      // Global targeting
      googletag.pubads().setTargeting('Section', [pageType])
      googletag.pubads().setTargeting('Environment', ['Live'])
      googletag.pubads().setTargeting('Environment-Preview', ['Preview'])
      googletag.pubads().enableSingleRequest()
      googletag.enableServices()
    })
  }, [pageType])
}
